module.exports = __webpack_public_path__ + "img/landing20.01de5c12.jpg";